import React, { useState, useEffect } from "react";
import SideMenu from "../components/SideMenu";
import Header from "../components/Header";
import UserMenu from "../components/UserMenu";
import { useSelector } from "react-redux";
import axios from "axios";
import API_BASE_URL from "../utilities/ApiConfig";
import { toast } from "react-toastify";
import ModifyReceiptTable from "../components/ModifyReceiptTable";
import loadercrs from "../assets/images/loadercrs.gif";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { TextField, MenuItem } from "@mui/material";
import HighestSaleDeedTable from "../components/HighestSaleDeedTable";
import { useLocation } from "react-router-dom";
import REPORT_BASE_URL from "../utilities/ReportConfig";

const TransactionReports = () => {
  const { userDetails } = useSelector((state) => state.auth);
  const today = dayjs(); // Use Dayjs for date handling

  const [selectedDeed, setSelectedDeed] = useState("");
  const [selectedTransaction, setSelectedTransaction] = useState("");
  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);
  const [allCashReceiptData, setAllCashReceiptData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedBehalfOf, setSelectedBehalfOf] = useState(""); // Controlled state for dropdown

  const deedTypes = [
    { id: "all_", value: "All" },
    { id: "sale_", value: "Sale" },
    { id: "sale_exagri_", value: "Sale (except Agriculture)" },
    { id: "aggre_", value: "Agreement" },
    { id: "gift_", value: "Gift" },
    { id: "gift_g_", value: "Gift (General)" },
    { id: "gift_f_", value: "Gift (Family)" },
    { id: "lease_", value: "Lease" },
  ];

  const transactionReports = [
    { id: "5", value: "5 Lakhs Report" },
    { id: "30", value: "30 Lakhs Report" },
    { id: "50", value: "50 Lakhs Report" },
  ];

  const handleOkButtonClick = () => {
    if (!fromDate || !toDate) {
      toast.error("Please select a date.");
      return;
    }

    const fDate = fromDate.format("DD-MMM-YYYY");
    const tDate = toDate.format("DD-MMM-YYYY");
    const mode = selectedDeed.toString() + selectedTransaction.toString();

    const reportUrl = `${REPORT_BASE_URL}/Report/TransactionReports.aspx?dcode=${userDetails.dcode}&srocode=${userDetails.srocode}&fdate=${fDate}&tdate=${tDate}&mode=${mode}`;

    window.open(reportUrl, "_blank");
    setSelectedDeed("");
    setSelectedTransaction("");
    setFromDate(today);
    setToDate(today);
  };
  // const fetchAllCashReceiptData = async (from, to) => {
  //   try {
  //     setLoading(true);
  //     const response = await axios.get(
  //       `${API_BASE_URL}/CashReceipt/load_receipt_for_modification/${userDetails.dcode}/${userDetails.srocode}/${from.format("YYYY-MM-DD")}/${to.format("YYYY-MM-DD")}`
  //     );
  //     setAllCashReceiptData(response.data);
  //   } catch (err) {
  //     setError("Failed to fetch data");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   fetchAllCashReceiptData(today, today);
  // }, []);

  return (
    <>
      {loading && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50 z-50">
          <img src={loadercrs} alt="Loading..." className="w-48 h-48" />
        </div>
      )}

      <div
        className={`flex h-screen ${
          loading ? "pointer-events-none blur-sm" : ""
        }`}
      >
        <SideMenu className="w-full md:w-64" />
        <div className="flex-1 flex flex-col overflow-hidden">
          <div className="shadow-sm">
            <Header />
          </div>
          <div className="flex flex-1 flex-col md:flex-row overflow-y-auto">
            <div className="flex-1 p-4 overflow-y-auto">
              <h1 className="text-xl md:text-2xl font-bold text-gray-800 mb-4 mx-4">
                Transaction Reports
              </h1>
              <div className="max-w-full mx-auto p-2 md:p-4 rounded-md">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 w-full px-10">
                  {/* From Date */}
                  <div className="col-span-2">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="From Date"
                        value={fromDate}
                        onChange={(newValue) => setFromDate(newValue)}
                        format="YYYY-MM-DD"
                        slotProps={{
                          textField: { fullWidth: true, size: "small" },
                        }}
                        required
                      />
                    </LocalizationProvider>
                  </div>

                  {/* To Date */}
                  <div className="col-span-2">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="To Date"
                        value={toDate}
                        onChange={(newValue) => setToDate(newValue)}
                        format="YYYY-MM-DD"
                        slotProps={{
                          textField: { fullWidth: true, size: "small" },
                        }}
                        required
                      />
                    </LocalizationProvider>
                  </div>

                  {/* Select Deed Type */}
                  <div className="col-span-2">
                    <TextField
                      select
                      label="Select Deed Type"
                      fullWidth
                      variant="outlined"
                      size="small"
                      value={selectedDeed}
                      onChange={(e) => setSelectedDeed(e.target.value)}
                      required
                    >
                      <MenuItem disabled value="">
                        Select
                      </MenuItem>
                      {deedTypes.map((type) => (
                        <MenuItem key={type.id} value={type.id}>
                          {type.value}
                        </MenuItem>
                      ))}
                    </TextField>
                  </div>

                  {/* Select Transaction Report */}
                  <div className="col-span-2">
                    <TextField
                      select
                      label="Select Transaction Report"
                      fullWidth
                      variant="outlined"
                      size="small"
                      value={selectedTransaction}
                      onChange={(e) => setSelectedTransaction(e.target.value)}
                      required
                    >
                      <MenuItem disabled value="">
                        Select
                      </MenuItem>
                      {transactionReports.map((report) => (
                        <MenuItem key={report.id} value={report.id}>
                          {report.value}
                        </MenuItem>
                      ))}
                    </TextField>
                  </div>

                  {/* OK Button - Responsive Centered */}
                  <div className="col-span-1 md:col-span-4 flex justify-center mt-4">
                    <button
                      className="w-full md:w-auto bg-blue-500 text-white text-sm px-6 py-2 rounded-md hover:bg-blue-600 focus:outline-none"
                      onClick={handleOkButtonClick}
                    >
                      OK
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="hidden md:block w-full md:w-64 h-full p-4">
              <UserMenu />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TransactionReports;
